<template>
  <div class="row pl-2 pr-2 pb-2">
    <!--DELETE POPUP-->
    <popup
        v-if="showDeletePrompt"
        @close="() => {showDeletePrompt = false;}"
    >
      <delete-prompt
          slot="popupMainContent"
          @abort="() => {showDeletePrompt = false; toBeDeletedAsset = null;}"
          @confirm="() => {showDeletePrompt = false; if(toBeDeletedAsset) {deleteFilter();}}"
      >
        <loading-panel v-if="loading"/>
        <div v-else-if="instanceList && instanceList.length">
          <br>{{ $t('willAlsoBeDeleted') }}
          <div v-for="(item, key) in instanceList" :key="key">
            {{ $t('ExportedProfiles') }}: {{ item.name ? item.name : item.asset.name }}<br>
            <span class="lighter">{{ $t('Created') }}:</span> {{ dateTimeFromISO(item.createdAt) }}<br><br>
          </div>
        </div>
      </delete-prompt>
    </popup>


    <!--BASE INFO-->
    <div class="col-12">
      <div
          class="close-icon float-right clickable"
          @click="abort">
        <icon
            class="clickable"
            size="1.5"
            type="xmark"
        />
      </div>
      <div class="checkbox-outer">
        <checkbox-widget
            :key="forceReRenderkey + 15"
            :initial-value="limitToSourceProject"
            :label-text="$t('filter.limitForThisAssembly')"
            class="mt-3 mb-3"
            label-for="limitToSourceProject"
            @change="(val) => { limitToSourceProject = val; }"
        />
      </div>
      <info-panel
          :collapsible="true"
          :initially-collapsed="!newFilter"
          class="new-style"
          info-panel-header="filter.EditFilter"
          preview-id="subversionForm"
      >
        <div slot="info">
          <filter-base-info-edit
              :key="forceReRenderkey"
              :description="description"
              :error="error"
              :filter-id="filterId"
              :name="name"
              :new-filter="newFilter"
              :organization-id="localOrganizationId"
              :teams="teams"
              :tags="tags"
              @loadAssetTeams="$emit('loadAssetTeams')"
              @loadAssetTags="$emit('loadAssetTags')"
              @updateDescription="(val) => { description = val; }"
              @updateError="(val) => { error = val; }"
              @updateName="(val) => { name = val; }"
              @updateOrganizationId="(val) => { localOrganizationId = val; }"
              @updateTeamId="(val) => { teamId = val; }"
          />
        </div>
      </info-panel>
    </div>


    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="filter.corrections"
              preview-id="correctionSection"
              :info-box-background-color="exportProfileColors.correction"
          >
            <div slot="info">
              <correction-section
                  :axis-multiplier="axisMultiplier"
                  :filter-id="filterId"
                  :pivot-placement="pivotPlacement"
                  :use-pivot-values="usePivotValues"
                  @updateAxisMultiplier="(val) => { axisMultiplier = val; }"
                  @updatePivotPlacement="(val) => { pivotPlacement = val; }"
                  @updateUsePivotValues="(val) => { usePivotValues = val; }"
              />
            </div>
          </info-panel>
        </div>
        <div class="col-12">
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="filter.filters"
              preview-id="filterSection"
              :info-box-background-color="exportProfileColors.filter"
          >
            <div slot="info">
              <filter-section
                  :key="forceReRenderkey + 5"
                  ref="metaFieldFilter"
                  :assembly-id="assemblyId"
                  :filter-id="filterId"
                  :meta-sets="metaSets"
                  :mode="mode"
                  :organization-id="localOrganizationId"
                  @removeAllSmallParts="removeAllSmallParts"
                  @removeTheHull="removeTheHull"
                  @setMode="setActive"
              />
            </div>
          </info-panel>
        </div>
        <div class="col-12">
          <info-panel
              :collapsible="true"
              :initially-collapsed="true"
              class="new-style bright"
              info-panel-header="filter.merge"
              preview-id="mergeSection"
              :info-box-background-color="exportProfileColors.merge"
          >
            <div slot="info">
              <merge-section
                  :key="forceReRenderkey + 10"
                  :assembly-id="assemblyId"
                  :filter-id="filterId"
                  :meta-sets="metaSets"
                  :organization-id="localOrganizationId"
                  @setActive="setActive"
              />
            </div>
          </info-panel>
        </div>
        <div v-if="$store.getters.isSuperAdmin" class="col-12">
          <div class="filter-section">
            <checkbox-widget
                :initial-value="false"
                :label-text="$t('filter.showCodeView')"
                class="mt-2"
                label-for="showCodeView"
                @change="(val) => {showCodeView = val}"
            />
            <codemirror
                v-if="showCodeView"
                :value="JSON.stringify($store.getters.getExportProfilesById(filterId))"
                class="col-12 mt-2 border-radius"
                @save="updateContent"
            />
          </div>
        </div>
      </div>
      <div class="button-box mt-3">
        <div
            :deactivated="!enableSaving && !saving"
            class="settings-button d-inline-block mr-3 switched-colors"
            @click="() => {if(filterId !== 'new') {update();} else {create();}}">
          <icon v-if="enableSaving" type="save"/>
          <icon v-else type="ban"/>
          {{ $t('SAVE') }}
          <loading-spinner v-if="saving" class="d-inline-block"/>
        </div>
        <div
            class="settings-button d-inline-block mr-3 switched-colors"
            @click="abort">
          <icon type="xmark"/>
          {{ $t('abort') }}
        </div>
        <div
            class="settings-button d-inline-block mr-3 switched-colors"
            @click="$emit('showPreview')">
          <icon type="eye"/>
          {{ $t('preview') }}
        </div>
        <div
            v-if="!newFilter && filterId"
            class="settings-button d-inline-block float-right switched-colors"
            @click="deleteFilter(filterId)"
        >
          {{ $t('delete') }}
          <icon class="ml-1" type="trash"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/Icon";
import {mapState} from 'vuex';
import DeletePrompt from "@/components/forms/DeletePrompt";
import Popup from "@/components/Popup";
import DateMixin from "@/components/mixins/DateMixin.js";
import LoadingPanel from "@/components/LoadingPanel";
import {PivotPositions, exportProfileColors} from "@/enum";
import Codemirror from "../widgets/editors/Codemirror";
import CheckboxWidget from "@/components/widgets/editors/Checkbox.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import FilterBaseInfoEdit from "@/components/sfxFilter/FilterBaseInfoEdit.vue";
import InfoPanel from "@/components/InfoPanel.vue";
import CorrectionSection from "@/components/sfxFilter/CorrectionSection.vue";
import FilterSection from "@/components/sfxFilter/FilterSection.vue";
import MergeSection from "@/components/sfxFilter/MergeSection.vue";
export default {
  name: "FilterAddForm",
  components: {
    Icon,
    FilterBaseInfoEdit,
    DeletePrompt,
    Popup,
    LoadingPanel,
    Codemirror,
    CheckboxWidget,
    LoadingSpinner,
    InfoPanel,
    CorrectionSection,
    FilterSection,
    MergeSection
  },
  mixins: [DateMixin],
  props: {
    organizationId: {type: String, default: ''},
    teams: {
      type: Array, default: () => {
      }
    },
    tags: {
      type: Array, default: () => []
    },
    /**
     * @param filterId add-form switches into edit mode of filter ID given
     * */
    filterId: {type: String, default: ""},
    assemblyId: {type: String, default: ''},
    projectId: {type: String, default: ''}, // the sourceProjectId of the assembly
    newFilter: {type: Boolean, default: false}
  },
  data() {
    return {
      exportProfileColors,
      showCodeView: false,
      saving: false,
      forceReRenderkey: 0,
      pivotPositions: PivotPositions,
      enableSaving: true,
      error: '',
      localOrganizationId: this.organizationId,
      metaSetId: '', // deprecated
      mergeMetaSetId: '', // deprecated
      hasLoaded: false,

      limitToSourceProject: false, // whether or not to limit the filter to this assembly only

      // creation
      name: '',
      type: 'filter',
      description: '',


      // deleting
      toBeDeletedAsset: null,
      showDeletePrompt: false,

      // loading
      instanceList: {},
      loading: false,
      localTeams: [],

      // corrections
      pivotMetaSetId: '',
      pivotField: '',
      usePivotValues: false,
      axisMultiplier: [0, 0, 0],
      pivotPlacement: 'source',

      // tabs
      activeTab: 'filter',
      tabs: [{
        name: 'Corrections',
        value: 'corr'
      }, {
        name: 'Simplify',
        value: 'filter'
      }, {
        name: 'Merge',
        value: 'merge'
      }, {
        name: 'Advanced',
        value: 'advanced'
      }],

      // active filtering
      filter: {},
      filterArray: [],
      filterIdArray: [],
      merge: {},
      mergeArray: [],
      mergeIdArray: [],
      filterStringArray: [],
      mergeStringArray: [],
      metaSets: [],
      mode: null,

      state: {},
    }
  },
  computed: mapState({
    currentUserOrg: state => state.users.currentUserOrg,
    exportProfiles: state => state.exportprofile.exportProfiles
  }),
  watch: {
    name() {
      this.error = null;
    },
    organizationId(val) {
      if (val) {
        this.localOrganizationId = this.organizationId;
      }
    },
    currentUserOrg(val) {
      if (!this.organizationId) {
        this.localOrganizationId = val;
      }
    },
    usePivotValues() {
      if (this.usePivotValues) {
        this.pivotField = 'sfx.asset.transform.preferredPivot'
      } else {
        this.pivotField = '';
      }
    },
  },
  beforeMount() {
    if (this.filterId !== 'new') {
      this.loadFilterData();
    } else {
      this.setBasicData();
    }
    this.loadMetaSets();
  },
  methods: {
    removeTheHull() {
      this.$refs.metaFieldFilter.removeTheHull();
    },
    removeAllSmallParts() {
      this.$refs.metaFieldFilter.removeAllSmallParts();
    },
    async updateContent(contentString) {
      let parsed = {};
      try {
        parsed = JSON.parse(contentString);
      } catch {
        console.log('parsing failed')
      }
      await this.$store.dispatch('importProfile', {value: parsed, id: this.filterId});
    },
    setActive(mode) {
      console.log('setActive', mode);
      this.$store.dispatch('overWriteFilterMode', {id: this.filterId, value: mode.value});
    },
    async loadMetaSets() {
      console.log('loadMetaSets');
      await this.$store.dispatch('clientLoadMetaSets', {
        include: 'metaFields',
        filter: 'organizationId in ' + this.$store.getters.getSuperOrg + ' ' + this.localOrganizationId ? this.localOrganizationId : this.organizationId
      }).then(metaSets => {
        this.metaSets = metaSets;
      })
    },
    // deprecated
    setMetaSet(metaSetName, metaSetId) {
      this.metaSetId = metaSetId;
    },
    // deprecated
    setMergingMetaSet(metaSetName, metaSetId) {
      this.mergeMetaSetId = metaSetId;
    },

    getEmptyObject() {
      return {
        filterStringArray: [],
        filter: [],
        filterIdArray: [],
        merge: [],
        mergeStringArray: [],
        mergeIdArray: [],
        pipeline: {
          subVersion: {
            mode: 'exclude',
            //axisMultiplier: null,
            //pivotField: null,
            //pivotMetaSetId: null,
            //usePivotValues: true,
          }
        }
      }
    },
    setBasicData() {
      const content = this.getEmptyObject();
      this.$store.dispatch('importProfile', {value: content, id: this.filterId});
    },
    loadFilterData() {
      this.$store.dispatch('loadFilter', {
        id: this.filterId,
      }).then(data => {
        let content;
        if (data) {
          const {sourceProjectId, name, description} = data;
          this.name = name;
          this.description = description;
          this.limitToSourceProject = !!sourceProjectId;
          this.forceReRenderkey++;
          if (data.content) {
            try {
              content = JSON.parse(data.content);
            } catch {
              content = this.getEmptyObject();
            }
            const {pipeline} = content;
            const {subVersion, axisMultiplier, pivotField, pivotMetaSetId, pivotPlacement} = pipeline;
            //this.filter = filter;

            if (subVersion.mode) {
              this.mode = subVersion.mode;
            } else {
              content.pipeline.subVersion.mode = 'exclude';
            }
            if (axisMultiplier) {
              this.axisMultiplier = axisMultiplier;
            }
            if (pivotField) {
              this.pivotMetaSetId = pivotMetaSetId;
              this.pivotField = pivotField;
              this.usePivotValues = true;
            }
            if (pivotPlacement) {
              this.pivotPlacement = pivotPlacement;
            }
          } else {
            content = this.getEmptyObject();
          }
          if (!content.filterStringArray) {
            content.filterStringArray = [];
          }
          if (!content.mergeStringArray) {
            content.mergeStringArray = [];
          }
          if (!content.mode) {
            content.mode = 'exclude';
          }
          if (!content.filter) {
            content.filter = [];
          }
          if (!content.merge) {
            content.merge = [];
          }
          this.$store.dispatch('importProfile', {value: content, id: this.filterId});
        }
        this.hasLoaded = true;
      });
    },
    loadFilterInstances() {
      this.loading = true;
      let args = {
        listName: this.listId + 'filterinstances',
        add: {
          filter: {
            filterAddForm: 'assetId eq ' + this.filterId
          },
          include: {
            filterAddForm: ['asset', 'project'],
          }
        }
      };
      this.$store.dispatch('loadAllFilterInstances', args).then(data => {
        this.instanceList = data;
        this.loading = false;
      });
    },
    /**
     * Gets the args to deliver to update or save function
     * */
    getArgs() {
      return {
        name: this.name,
        teams: this.localTeams,
        description: this.description,
        type: 'filter',
        sourceProjectId: this.limitToSourceProject ? this.projectId : null,
        content: JSON.stringify({
          filterVersion: 1.1,
          pipeline: {
            axisMultiplier: [Number(this.axisMultiplier[0]), Number(this.axisMultiplier[1]), Number(this.axisMultiplier[2])],
            pivotPlacement: this.pivotPlacement,
            pivotField: this.pivotField,
            pivotMetaSetId: this.pivotMetaSetId,
            // subVersion is legacy
            subVersion: {
              mode: this.$store.getters.getExportFilterModeById(this.filterId)
            },
          },
          mode: this.$store.getters.getExportFilterModeById(this.filterId),
          filter: this.$store.getters.getExportFilterById(this.filterId),
          filterStringArray: this.$store.getters.getExportFilterStringById(this.filterId),
          merge: this.$store.getters.getMergeById(this.filterId),
          mergeStringArray: this.$store.getters.getExportMergeStringById(this.filterId),
          filterIdArray: this.$store.getters.getExportFilterIdArrayById(this.filterId),
          mergeIdArray: this.$store.getters.getExportMergeIdArrayById(this.filterId),
        })
      };
    },
    async update() {
      this.saving = true;
      let args = this.getArgs();
      args.id = this.filterId;
      await this.$store.dispatch('updateFilter', args)
          .then(() => {
            this.$emit('updated', {isGlobal: !this.limitToSourceProject});
            console.log('updated');
            this.saving = false;
          }).catch(e => {
            console.log(e);
            this.error = e;
            this.saving = false;
          });
    },
    async create() {
      this.saving = true;
      let args = this.getArgs();
      args.organizationId = this.localOrganizationId;
      if (this.teams) {
        args.teams = this.teams;
      }
      if (this.teamId) {
        args.teams = [this.teamId];
      }
      await this.$store.dispatch('createFilter', args)
          .then(item => {
            this.$emit('created', item);
            this.saving = false;
          }).catch(e => {
            console.log(e);
            this.error = e;
            this.saving = false;
          });
    },
    /**
     * Aborts editing
     * */
    abort() {
      this.$emit('aborted');
    },
    /**
     * Deletes a filter item
     * */
    deleteFilter(id) {
      if (this.toBeDeletedAsset) {
        this.$store.dispatch('deleteFilters', [this.toBeDeletedAsset])
            .then(() => {
              this.$emit('deleted');
            });
        this.showDeletePrompt = false;
        this.toBeDeletedAsset = null;
      } else {
        this.toBeDeletedAsset = id;
        this.loadFilterInstances();
        this.showDeletePrompt = true;
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.filter-section {
  margin-bottom: 15px;
  border: 1px solid var(--vform-editor-ui-quinary-color);
  border-radius: 3px;
  background-color: var(--vform-editor-ui-secondary-color);
  padding: 5px 5px;
}

.search-field {
  width: 200px;
}

.include-exclude {
  max-width: 200px;
}

.mod-selector {
  width: 200px;
  display: inline-block;
}

.form-text-dark {
  margin: 0;
  padding: 0;
  font-size: 0.8rem;
}

.checkbox-outer {
  max-width: 300px;
}
</style>